import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { CopyChecklistServicoForm, CopyChecklistServicoSchema } from "../../../schemas/ChecklistServico_lista/copy_checklist_servico";
import { ChecklistServico } from "../../../../domain/models/checklist_servico";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * CopyChecklistServicoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedChecklistServico: ChecklistServico | null,
  onClose: (idChecklistServico: number | null, openState: boolean) => void;
  onSubmit: (form: CopyChecklistServicoForm) => void;
};

export const CopyChecklistServicoModal = ({
  open,
  saving,
  loading,
  selectedChecklistServico,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(CopyChecklistServicoSchema),
  });

  useEffect(() => {
    if (open) {
      if (selectedChecklistServico) {
        hookForm.reset();
        hookForm.setValue('codigo', selectedChecklistServico.codigo ?? '');
        hookForm.setValue('nroRevisao', selectedChecklistServico.revisao ?? '');
        hookForm.setValue('descricao', selectedChecklistServico.descricao ?? '');
      }
    }
  }, [
    open,
    selectedChecklistServico,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      width="50rem"
      title='Checklist de serviço'
      onClose={() => onClose(null, false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col">
        <FormContainer title='Informações' arrangement='fullRow' gap='small' border={false}>
          <>
            <DefaultFormInput
              name='codigo'
              label='Código do Checklist'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='nroRevisao'
              label='Nº da revisão'
              readOnly={saving}
              required={true}
              reactHookForm={hookForm}
            />

            <DefaultFormInput
              name='descricao'
              label='Descrição do Checklist'
              readOnly={saving}
              required={true}
              multiline={true}
              rows={5}
              reactHookForm={hookForm}
            />
          </>
        </FormContainer>
      </div>
    </BaseFormControlledModal >
  );
}